import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-6/mainSection-multiple-inputs-v-6';
import DynamicDuplicate from '../software-dynamic-version-5/check-duplicate-v-5'
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import securityService from '../security/security.service';
import saleInvoiceService from './sale-invoice.service';
import DynamicInputGrid from '../software-dynamic-version-5/popup-input-grid-v-5'
import DialogInput from '../software-dynamic/popup-dialog-input'

const SaleInvoiceAdd = (props) => { 
  console.log(props)
  const toastInstance = useRef(null);

  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};

  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
  
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key], // Spread the inner object to update its properties
          };
        }
      });
  
      return updatedValues;
    });
  };
  // InvoiceOpeningID	InvoiceTypeID	InvoiceID	InvoiceOpeningDate	ModuleID	AccountID	PaymentDays	ExcludingTaxAmount
  // 	TaxAmount	RoundingAmount	Remarks	CreationDate	CreatedByUserID	UpdationDate	UpdatedByUserID	IsDeleted	DeletionDate	DeletedByUserID	IsApproved	ApprovedByUserID	ApprovedByDate
  
  const [inputProps, setInputProps] = useState({
    
    ValidMainSectionValues:{name: 'ValidMainSectionValues',   value:[] },

    GridDataSource:{name: 'GridDataSource',   value:[] },
    CallGridDataSource:{name: 'CallGridDataSource',   value:false },

    SelectRowByID:{name: 'SelectRowByID', value:false },
    
    loadingMainSection:{name: 'loadingMainSection', value:true },


    // invoiceType:{name: 'invoiceType',   value: props.invoiceType || 'Sale Invoice' },
    invoiceType:{
      name:{id:'invoiceTypeID',value:'invoiceType'},
      caption: 'Select  invoice Type',
      value: {id: props?.invoiceTypeID || 4 ,value:props?.invoiceType || 'Sale Invoice'},
      dataSource: {type:'Data',data:[]},
      enabled:false
    },
    
    invoiceDate:{name: "invoiceDate",   value: props.invoiceDate || 'currentDate' , enabled:false },


    CompanyID:{name: "CompanyID",   value: props.CompanyID  },
    sellerBusinessName:{name: "sellerBusinessName",   value: props.sellerBusinessName ,enabled:false },
    sellerNTNCNIC:{name: "sellerNTNCNIC", caption: 'seller NTN/CNIC',  value: props.sellerNTNCNIC, enabled:false },
    sellerProvince:{name: "sellerProvince",   value: props.sellerProvince, enabled:false },
    sellerAddress:{name: "sellerAddress",   value: props.sellerAddress ,enabled:false },

    
    
    Seller:{
      name:{id:'SellerID',value:'Seller'},
      caption: 'Select Buyer',
      value: {id: props?.buyerNTNCNIC  ,value:props?.buyerBusinessName || ''},
      dataSource: {type:'Route',route:'buyer'},
      addNew:{Route:'Buyer',Security:'Buyer'}
    },
    buyerBusinessName:{name: "buyerBusinessName",   value: props.buyerBusinessName  },
    buyerNTNCNIC:{name: "buyerNTNCNIC", caption: 'buyer NTN/CNIC',  value: props.buyerNTNCNIC,enabled:false  },
    buyerProvince:{name: "buyerProvince",   value: props.buyerProvince ,enabled:false },
    buyerProvinceCode:{name: "buyerProvinceCode",   value: props.buyerProvinceCode , enabled:false },
    buyerAddress:{name: "buyerAddress",   value: props.buyerAddress ,enabled:false  },
    
    buyerRegistrationType:{name: "buyerRegistrationType",   value: props.buyerRegistrationType ,enabled:false  },
    invoiceRefNo:{name: "invoiceRefNo",   value: props.invoiceRefNo  ||  ''  },
    scenarioId:{name: "scenarioId",   value: props?.scenarioId || '' },
    
    saleType:{
      name:{id:'saleTypeID',value:'saleType'},
      caption: 'Select  sale Type',
      value: {id: props?.transactioN_TYPE_ID  ,value:props?.transactioN_DESC || ''},
      dataSource: {type:'Data',data:[]},
      isControlBlur:false

    },
    
    
        
    

    // DETAIL SECTIONS INPUTS START
    rowID:{name: "rowID",   value: props.rowID  },

    hsCode:{
      name:{id:'hsCodeID',value:'hsCode'},
      caption: 'HSCode Description',
      value: {id: props?.hsCode  ,value: ''},
      dataSource: {type:'Data',data:[]},
      isControlBlur:false

    },
    productDescription:{name: "productDescription",  caption:'Product Description',  value: props.productDescription  },
    
    
    ratE_VALUE:{name: "ratE_VALUE",  caption:'ratE_VALUE',  value: props.ratE_VALUE || 0},
    
    rate:{
      name:{id:'rateID',value:'rate'},
      caption: 'Rate',
      value: {id: props?.ratE_ID  ,value:props?.ratE_DESC || ''},
      dataSource: {type:'Data',data:[]},
      isControlBlur:false

    },
    
    uoM:{
      name:{id:'uoMID',value:'uoM'},
      caption: 'UoM',
      value: {id: props?.uoM_ID  ,value:props?.uoM_DESC || ''},
      dataSource: {type:'Data',data:[]},
      isControlBlur:false

    },
    quantity:{name: "quantity",  caption:'Quantity', value: props.quantity || 0.00 ,decimal:2  },
    totalValues:{name: "totalValues", caption: 'Total Value',   enabled:false,  value: props.totalValues || 0 ,decimal:2 ,formula:'valueSalesExcludingST + salesTaxApplicable + fixedNotifiedValueOrRetailPrice + extraTax + furtherTax + fedPayable + salesTaxWithheldAtSource - discount' },
    valueSalesExcludingST:{name: "valueSalesExcludingST",  caption: 'Value of Sales Excl ST',  value: props.valueSalesExcludingST || 0 ,decimal:0  },
    fixedNotifiedValueOrRetailPrice:{name: "fixedNotifiedValueOrRetailPrice",   caption:'Fixed/Notified value or Retail Price', value: props.fixedNotifiedValueOrRetailPrice || 0 ,decimal:0  },
    salesTaxApplicable:{name: "salesTaxApplicable", enabled:false,  caption:'Sales Tax', value: props.salesTaxApplicable || 0 ,decimal:2 ,formula:'valueSalesExcludingST * (ratE_VALUE/100)' },
    salesTaxWithheldAtSource:{name: "salesTaxWithheldAtSource",   caption:'ST Withheld at Source', value: props.salesTaxWithheldAtSource || 0 ,decimal:0  },
    extraTax:{name: "extraTax",  caption:'Extra Tax',  value: props.extraTax || '' },
    furtherTax:{name: "furtherTax",  caption:'Further Tax',  value: props.furtherTax || 0 ,decimal:0  },
    // sroScheduleNo:{name: "sroScheduleNo",   value: props.sroScheduleNo || '' },
    sroScheduleNo:{
      name:{id:'sroScheduleNoID',value:'sroScheduleNo'},
      caption: 'SRO/Schedule No',
      value: {id: props?.sroScheduleNoID  ,value:props?.sroScheduleNo || ''},
      dataSource: {type:'Data',data:[]},
      isControlBlur:false
    },
    
    fedPayable:{name: "fedPayable",   caption:'FED Payable', value: props.fedPayable || 0 ,decimal:0  },
    discount:{name: "discount",  caption:'Discount',  value: props.discount || 0 ,decimal:0  },
  //  sroItemSerialNo:{name: "sroItemSerialNo",   value: props.sroItemSerialNo || '' },
  sroItemSerialNo:{
    name:{id:'sroItemSerialID',value:'sroItemSerialNo'},
    caption: 'Item Sr. No',
    value: {id: props?.sroItemSerialID  ,value:props?.sroItemSerialNo || ''},
    dataSource: {type:'Data',data:[]},
    isControlBlur:false

  },
  

    AddButton:{name: "AddButton",  caption:'Insert' ,enabled:false,isClicked:false},
    UpdateButton:{name: "UpdateButton",  caption:'Update' ,enabled:false,isClicked:false},
  });

  
// EXTRA CODE START

 const SaveButton = (GridID, visibility) => {
    const btn = document.querySelector(`#${GridID}Grid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`);
    if (btn) btn.style.visibility = `${visibility}`;
  }
// UPDATE SEND DETAILS PROPS
const updateSendDetails = ()=>{
  let mainData = {}
  setInputProps((prevValues) => {
    console.log(prevValues);
    mainData = prevValues
    return {...prevValues
   }});
   console.log(mainData)
  console.log(inputProps)
  let validObject = {
    // invoiceType:mainData.ValidMainSectionValues.value.invoiceType || document.getElementById('invoiceType').value,
    // invoiceDate:mainData.ValidMainSectionValues.value.invoiceDate,
    // sellerNTNCNIC:mainData.ValidMainSectionValues.value.sellerNTNCNIC,
    // sellerBusinessName:mainData.ValidMainSectionValues.value.sellerBusinessName,
    // sellerProvince: mainData.ValidMainSectionValues.value.sellerProvince,
    // sellerAddress: mainData.ValidMainSectionValues.value.sellerAddress,
    // buyerNTNCNIC: mainData.ValidMainSectionValues.value.buyerNTNCNIC,
    // buyerBusinessName: mainData.ValidMainSectionValues.value.buyerBusinessName,
    // buyerProvince: mainData.ValidMainSectionValues.value.buyerProvince,
    // buyerAddress: mainData.ValidMainSectionValues.value.buyerAddress,
    // buyerRegistrationType: mainData.ValidMainSectionValues.value.buyerRegistrationType,
    // invoiceRefNo:mainData.ValidMainSectionValues.value.invoiceRefNo ,
    invoiceType:mainData.invoiceType.value.value || document.getElementById('invoiceType').value,
    invoiceDate:moment(mainData.invoiceDate.value).format('YYYY-MM-DD') || '2025-06-30',
    sellerNTNCNIC:mainData.sellerNTNCNIC.value,
    sellerBusinessName:mainData.sellerBusinessName.value,
    sellerProvince: mainData.sellerProvince.value,
    sellerAddress: mainData.sellerAddress.value,
    buyerNTNCNIC: mainData.buyerNTNCNIC.value,
    buyerBusinessName: mainData.buyerBusinessName.value,
    buyerProvince: mainData.buyerProvince.value,
    buyerAddress: mainData.buyerAddress.value,
    buyerRegistrationType: mainData.buyerRegistrationType.value,
    invoiceRefNo:mainData?.invoiceRefNo?.value || '' ,

    
    scenarioId:props.isTesting == true? (mainData?.scenarioId?.value || '').toUpperCase() : '',
    // items:mainData.GridDataSource.value
    items: mainData.GridDataSource.value.map(({ rowID,hsCodeValue,invoiceType, invoiceDateForGrid,...rest }) => rest)

  }

  console.log(validObject)
        setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 700);

  props.sendDetails(validObject)
}

const getSaleTypeDataSource = async (CompanyID = inputProps.CompanyID.value)=>{
  let response = await saleInvoiceService.getsaleTypeDataSource(CompanyID);
  if(response){
    console.log(response);
    let saleTypeDataSource = response.data.map((row)=> { return {id:row.transactioN_TYPE_ID ,value:row.transactioN_DESC}});
    console.log(saleTypeDataSource);
    updateMainSecionsValue(
      {
        saleType:{
          dataSource: {type:'Data',data:saleTypeDataSource || []}
        }
      }
    )
  }
}
  const getCompanyDetails = async ()=>{
    let response = await saleInvoiceService.getCompanyView()
    if(response){
      updateMainSecionsValue({
        CompanyID:{value:response.data.recordset[0].CompanyID},
        sellerBusinessName:{value:response.data.recordset[0].CompanyName},
        sellerNTNCNIC:{value:response.data.recordset[0].CompanyNTNCNIC},
        sellerProvince:{value:response.data.recordset[0].CompanyProvinceName},
        sellerAddress:{value:response.data.recordset[0].CompanyAddress}
      })
      getSroItemCodeSource(response.data.recordset[0].CompanyID , inputProps.invoiceDate.value , inputProps.sroScheduleNo.value.id ||'') 
      getHSCodeSource(false , response.data.recordset[0].CompanyID);
      getSaleTypeDataSource(response.data.recordset[0].CompanyID);
      getInvoicTypeDoc(response.data.recordset[0].CompanyID);
      getUOMDataSource(
        response.data.recordset[0].CompanyID,
        inputProps.hsCode.value.id,
        3
      )
    }
    }




    //  ==== CAPILALIZE STRING VALUE FUNC ===== START
    
  const capitalizeWord = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
//  ==== CAPILALIZE STRING VALUE FUNC ===== END

  const getBuyerRegistrationType = async (BuyerNTNCNIC)=>{
    let data = {
      Registration_No:BuyerNTNCNIC,
      CompanyID:inputProps.CompanyID.value
    }

    console.log(data)
    let response = await saleInvoiceService.getBuyerRegistrationType(data)
    console.log(response)
    if(response){
      updateMainSecionsValue({
        buyerRegistrationType:{value:capitalizeWord(response?.data?.REGISTRATION_TYPE || '')},
        
      })
    }
    }

 
    const getInvoicTypeDoc = async (CompanyID = inputProps.CompanyID.value)=>{
      let response = await saleInvoiceService.getDoctypeCode(CompanyID);
      if(response){
        console.log(response);
        let invoiceTypeDataSource = response.data.map((row)=> { return {id:row.docTypeId ,value:row.docDescription}});
        console.log(invoiceTypeDataSource);
        let invoiceTypeValue = invoiceTypeDataSource.filter((row)=> row.id == 4);
        
        updateMainSecionsValue(
          {
            invoiceType:{
              dataSource: {type:'Data',data:invoiceTypeDataSource || []}
            }
          }
        )
        if(invoiceTypeValue.length > 0){
          updateMainSecionsValue({
            invoiceType:{value:
              {id:invoiceTypeValue[0]?.id,value:invoiceTypeValue[0]?.value}
            }
          })
          
          document.getElementById('invoiceType').value = invoiceTypeValue[0]?.value
         
        }
      }
    }


    useEffect(()=>{
      
      if(document.getElementById('Seller')){
        document.getElementById('Seller').focus()
        
       
        }
    },[])
// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  if(name == 'Seller'){
    updateMainSecionsValue({
      invoiceType:{enabled:true
      }
    })

  }
  if(name == 'sellerAddress'){
    getCompanyDetails()
  }
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };

const handleInputChange = async (value, name) => {
  if(name == 'Seller' && value.id){
    updateMainSecionsValue({
      buyerBusinessName:{value:value.itemData.buyerBusinessName},
      buyerNTNCNIC:{value:value.itemData.buyerNTNCNIC},
      buyerProvince:{value:value.itemData.buyerProvinceName},
      buyerAddress:{value:value.itemData.buyerAddress},
      buyerProvinceCode:{value:value.itemData.stateProvinceCode}
    })  
    getSroScheduleNoSource(
      { 
        rate:inputProps.rate.value.id ,
        invoiceDate: inputProps.invoiceDate.value,
        buyerProvinceCode:value.itemData.stateProvinceCode,
        CompanyId:inputProps.CompanyID.value
      }
    )
    getBuyerRegistrationType(value.itemData.buyerNTNCNIC)
    getRateDataSource(
      inputProps.CompanyID.value.id,
      inputProps.invoiceDate.value,
      inputProps.saleType.value.id,
      value.itemData.stateProvinceCode,
    )
  }

  if(name == 'saleType' || name == 'buyerProvince'){
    getRateDataSource(
      inputProps.CompanyID.value.id,
      inputProps.invoiceDate.value,
      name == 'saleType' ? value.id : inputProps.saleType.value.id,
      inputProps.buyerProvinceCode.value,
    )
  }
  if(name == 'invoiceDate' && inputProps.saleType.value.id && inputProps.buyerProvinceCode.value){
    getRateDataSource(
      inputProps.CompanyID.value.id,
      value || inputProps.invoiceDate.value,
      inputProps.saleType.value.id,
      inputProps.buyerProvinceCode.value,
    )
  }

  if(name == 'hsCode'){
    getUOMDataSource(
      inputProps.CompanyID.value.id,
      value.id || inputProps.hsCode.value.id,
      3
    )
    
  }


  if(name == 'rate'){
    console.log(value)
    updateMainSecionsValue({
      ratE_VALUE:{value:value?.itemData?.ratE_VALUE || 0}
        })
  }

  if(name == 'hsCode' || name == 'rate' || name == 'uoM'){
    updateMainSecionsValue({
      AddButton:{enabled:true,isClicked:false}
        })
  let hsCodeValue =   inputProps.hsCode.value.id;
  let rateValue =  inputProps.rate.value.id;
  let uoMValue =   inputProps.uoM.value.id;
  
  // if(hsCodeValue &&  rateValue && uoMValue){
  //     }else{
  //   updateMainSecionsValue({
  //     AddButton:{enabled:false,isClicked:false}
  //       })

  // }





  // call datasource for sro schedule dd
  if(name == 'invoiceDate' || name == 'rate' || name == 'Seller' ||  name == 'CompanyID'){
    getSroScheduleNoSource(
      { 
        rate:name == 'rate' ? value.id :inputProps.rate.value.id ,
        invoiceDate: name == 'invoiceDate' ? value :inputProps.invoiceDate.value,
        buyerProvinceCode: name == 'Seller' ?  value.itemData.stateProvinceCode  : inputProps.buyerProvinceCode.value,
        CompanyId:name == 'CompanyID' ? value  :inputProps.CompanyID.value}
    )
  }
  
  }

  // call datasource for sro iem code dd
  if(name == 'invoiceDate'  || name == 'sroScheduleNo' ||  name == 'CompanyID'){
    getSroItemCodeSource(
      name == 'CompanyID' ? value  :inputProps.CompanyID.value, 
      name == 'invoiceDate' ? value :inputProps.invoiceDate.value,
      name == 'sroScheduleNo' ? value.id || '' :inputProps.sroScheduleNo.value.id ||'')
  
  }
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    {Input: DropdownComponent ,Props: {...inputProps.invoiceType, setInputProps },ColumnSize:4},
    {Input: HiddenComponent ,Props: {...inputProps.CompanyID, setInputProps },ColumnSize:0},
    
    {Input: TextComponent,Props: {...inputProps.sellerBusinessName,setInputProps },ColumnSize:4},
    {Input: HiddenComponent,Props: {...inputProps.buyerBusinessName,setInputProps },ColumnSize:0},
    {Input: DropdownComponent,Props: {...inputProps.Seller,setInputProps ,onChange:handleInputChange,onCreated:handleInputCreated},ColumnSize:4},
    // {Input: TextComponent,Props: {...inputProps.buyerNTNCNIC,setInputProps  },ColumnSize:3},
    {Input: HiddenComponent,Props: {...inputProps.buyerNTNCNIC,setInputProps  },ColumnSize:0},
    {Input: TextComponent,Props: {...inputProps.buyerRegistrationType,setInputProps  },ColumnSize:4},
    
    {Input: DateComponent,Props: {...inputProps.invoiceDate,setInputProps ,onChange:handleInputChange },ColumnSize:4},
    {Input: TextComponent,Props: {...inputProps.sellerProvince,setInputProps },ColumnSize:4},
    {Input: TextComponent,Props: {...inputProps.buyerProvince,setInputProps,onChange:handleInputChange  },ColumnSize:4},
    {Input: DropdownComponent,Props: {...inputProps.saleType,setInputProps,onChange:handleInputChange  },ColumnSize:4},
    {Input:props.isTesting == true? TextComponent : HiddenComponent,Props: {...inputProps.scenarioId,setInputProps  },ColumnSize:props.isTesting ? 4:0},


    {Input: HiddenComponent,Props: {...inputProps.sellerNTNCNIC,setInputProps },ColumnSize:0},
    {Input: HiddenComponent,Props: {...inputProps.sellerAddress,setInputProps ,onCreated:handleInputCreated},ColumnSize:0},
    
    {Input: HiddenComponent,Props: {...inputProps.buyerProvinceCode,setInputProps },ColumnSize:0},
    {Input: HiddenComponent,Props: {...inputProps.buyerAddress,setInputProps  },ColumnSize:3},
    {Input: HiddenComponent,Props: {...inputProps.invoiceRefNo,setInputProps },ColumnSize:0},
    
    
    
    ];
 
//  DETAIL SECTION START
//  DETAIL SECTION START
//  DETAIL SECTION START
//  DETAIL SECTION START

const getHSCodeSource = async (Inputfocus = false , CompanyID = inputProps.CompanyID.value)=>{
    let response = await saleInvoiceService.getItemDescCode(CompanyID);
    if(response){
      console.log(response);
      let hsCodeDataSource = response.data.map((row)=> { return {id:row.hS_CODE ,value:`${row.hS_CODE} | ${row.description}`}});
      console.log(hsCodeDataSource);
      updateMainSecionsValue(
        {
          hsCode:{
            dataSource: {type:'Data',data:hsCodeDataSource || []}
          }
        }
      )
      if(Inputfocus == true ){
      setTimeout(() => {
        document.getElementById('hsCode').focus()
      }, 500);
    }
    }
}
// CompanyID=1&date=24-Feb-2024&transTypeId=18&originationSupplier=1
const getRateDataSource = async (
  CompanyID = inputProps.CompanyID.value,
  date = inputProps.invoiceDate.value,
  transTypeId = inputProps.saleType.value.id ,
  originationSupplier = inputProps.buyerProvinceCode.value)=>{
    let data = {
      CompanyID,
    date: moment(date).format('DD-MMM-YYYY'),
    transTypeId,
    originationSupplier
  }
  console.log(data)
  if(data.transTypeId && data.CompanyID && data.originationSupplier){
    let response = await saleInvoiceService.getRateDDSource(data);
    if(response){
      console.log(response);
      let rateDataSource = response.data.map((row)=> { return {id:row.ratE_ID ,value:row.ratE_DESC,...row}});
      console.log(rateDataSource);
      updateMainSecionsValue(
        {
          rate:{
            dataSource: {type:'Data',data:rateDataSource || []}
          }
        }
      )
    }
  } 
}


const getUOMDataSource = async (
  CompanyID = inputProps.CompanyID.value,
  hs_code = inputProps.hsCode.value.id,
  annexure_id = 3)=>{
    let data = {
      CompanyID,
      hs_code,
      annexure_id
  }
  console.log(data)
  if(data.hs_code){
    let response = await saleInvoiceService.getUOMDDSource(data);
    if(response){
      console.log(response);
      let uoMDataSource = response.data.map((row)=> { return {id:row.uoM_ID ,value:row.description}});
      console.log(uoMDataSource);
      updateMainSecionsValue(
        {
          uoM:{
            dataSource: {type:'Data',data:uoMDataSource || []}
          }
        }
      )
    }
  } 
}

const getSroScheduleNoSource = async ( params = {})=>{
  let { rate ,invoiceDate ,buyerProvinceCode ,CompanyId} = params;
  let rate_id = rate ?? inputProps?.rate?.value?.id;
  let date = invoiceDate ?? inputProps?.invoiceDate?.value;
  let origination_supplier_csv = buyerProvinceCode ?? inputProps?.buyerProvinceCode?.value;
  let CompanyID = CompanyId ?? inputProps?.CompanyID?.value;
    let paramsObject = {
      rate_id,
      date: moment(date).format('DD-MMM-YYYY'),
      origination_supplier_csv,
      CompanyID
  }
  console.log(paramsObject);
  if(!paramsObject.rate_id || !paramsObject.origination_supplier_csv || !paramsObject?.CompanyID) return;

  let { data } = await saleInvoiceService.getSroScheduleDD(paramsObject);
  
  console.log(data)

   let records = data || []

   let recordsMapping = records.map((row)=> { return {id:row?.srO_ID,value:row?.srO_DESC}})

    console.log(recordsMapping);
    updateMainSecionsValue({sroScheduleNo:{ dataSource: {type:'Data',data:recordsMapping || []}}})
  
}
const getSroItemCodeSource = async (CompanyId,invoiceDate,sroScheduleID)=>{
  let CompanyID = CompanyId ?? inputProps?.CompanyID?.value;
  let date = invoiceDate ?? inputProps?.invoiceDate?.value;
  let sro_id = sroScheduleID ?? inputProps?.sroScheduleNo?.value?.id;

    let paramsObject = {
      sro_id ,
      date: moment(date).format('YYYY-MM-DD'),
      CompanyID
  }
  console.log(paramsObject);
  if(!paramsObject?.CompanyID   || !paramsObject?.sro_id) return;

  let { data } = await saleInvoiceService.getSroItemCode(paramsObject);
  
  console.log(data)

   let records = data || []

   let recordsMapping = records.map((row)=> { return {id:row?.srO_ITEM_ID,value:row?.srO_ITEM_DESC}})

    console.log(recordsMapping);
    updateMainSecionsValue({sroItemSerialNo:{ dataSource: {type:'Data',data:recordsMapping || []}}})
  
}



const resetDetailSection = (shouldFocusOnHSCode  = true) =>{
   // DETAIL SECTIONS INPUTS START
 
   document.getElementById('hsCode').value = ''
   document.getElementById('rate').value = ''
   document.getElementById('uoM').value = ''
   document.getElementById('sroScheduleNo').value = ''
   document.getElementById('sroItemSerialNo').value = ''
   updateMainSecionsValue({
    hsCode:{value: {id: undefined  ,value: ''}},
    productDescription:{value: props.productDescription || ''},
    rate:{
      value: {id: props?.ratE_ID  ,value:props?.ratE_DESC || ''}},
    uoM:{
        value: {id: props?.uoM_ID  ,value:props?.uoM_DESC || ''}},
    quantity:{value: props.quantity || 0 },
    totalValues:{value: props.totalValues || 0  },
    valueSalesExcludingST:{value: props.valueSalesExcludingST || 0},
    fixedNotifiedValueOrRetailPrice:{value: props.fixedNotifiedValueOrRetailPrice || 0 },
    salesTaxApplicable:{ value: props.salesTaxApplicable || 0 },
    salesTaxWithheldAtSource:{ value: props.salesTaxWithheldAtSource || 0  },
    extraTax:{value: props.extraTax || '' },
    furtherTax:{  value: props.furtherTax || 0 },
    sroScheduleNo:{  value: {id:undefined, value:props.sroScheduleNo || ''} },
    fedPayable:{value: props.fedPayable || 0  },
    discount:{value: props.discount || 0  },
    sroItemSerialNo:{ value:{id:undefined ,value: props.sroItemSerialNo || ''} },

   })
   if(shouldFocusOnHSCode == true){
    getHSCodeSource(true)
   }

}
const handleInputClicked = async  (name) => {
  console.log(name);
  updateMainSecionsValue({
   AddButton:{enabled:true,isClicked:false}
     })
  if(name == 'AddButton'){
    insertRow()
  }else if(name == 'UpdateButton'){
    insertRow(true) 
  }
};

let inputsDetailList = [  
  {Input: ()=>{return(<><h4 style={{padding:'4px',paddingBottom:'0px'}}> Detail Section</h4> <hr/></>)},Props: {name:'Detail-Heading',setInputProps },ColumnSize:12},

  {Input:HiddenComponent,Props: {...inputProps.rowID,setInputProps ,onChange:handleInputChange},ColumnSize:0},
  {Input: DropdownComponent,Props: {...inputProps.hsCode,setInputProps ,onChange:handleInputChange},ColumnSize:4},
  {Input: TextComponent,Props: {...inputProps.productDescription,setInputProps },ColumnSize:4},
  {Input: DropdownComponent,Props: {...inputProps.rate,setInputProps ,onChange:handleInputChange},ColumnSize:4},
  // {Input: NumberComponent,Props: {...inputProps.ratE_VALUE,setInputProps ,//onChange:handleInputChange},//   ColumnSize:0},
  {Input: DropdownComponent,Props: {...inputProps.uoM ,setInputProps ,onChange:handleInputChange},ColumnSize:4},

  {Input: NumberComponent,Props: {...inputProps.quantity,setInputProps },ColumnSize:4},
  {Input: NumberComponent,Props: {...inputProps.valueSalesExcludingST,setInputProps },ColumnSize:4},
  {Input: NumberComponent,Props: {...inputProps.salesTaxApplicable,setInputProps },ColumnSize:4},

  {Input: NumberComponent,Props: {...inputProps.fixedNotifiedValueOrRetailPrice,setInputProps },ColumnSize:4},
  {Input: NumberComponent,Props: {...inputProps.salesTaxWithheldAtSource,setInputProps },ColumnSize:4},
  {Input: TextComponent,Props: {...inputProps.extraTax,setInputProps },ColumnSize:4},

  {Input: NumberComponent,Props: {...inputProps.furtherTax,setInputProps },ColumnSize:4},
  {Input: NumberComponent,Props: {...inputProps.fedPayable,setInputProps },ColumnSize:4},
  {Input: NumberComponent,Props: {...inputProps.discount,setInputProps },ColumnSize:4},
  {Input: NumberComponent,Props: {...inputProps.totalValues,setInputProps },ColumnSize:4},
  
  
  {Input: DropdownComponent,Props: {...inputProps.sroScheduleNo,setInputProps ,onChange:handleInputChange},ColumnSize:4},
  {Input: DropdownComponent,Props: {...inputProps.sroItemSerialNo,setInputProps ,onChange:handleInputChange},ColumnSize:4},



  // {Input: TextComponent,Props: {...inputProps.sroScheduleNo,setInputProps }},
  // {Input: TextComponent,Props: {...inputProps.sroItemSerialNo,setInputProps }},
  
  {Input: inputProps.UpdateButton.enabled == true ? HiddenComponent : ButtonComponent,Props: {...inputProps.AddButton,setInputProps,onClick:handleInputClicked },ColumnSize:inputProps.UpdateButton.enabled == true ? 0 : 1},
  {Input: inputProps.UpdateButton.enabled == true ? ButtonComponent : HiddenComponent,Props: {...inputProps.UpdateButton,setInputProps,onClick:handleInputClicked },ColumnSize:inputProps.UpdateButton.enabled == true ? 1 : 0}
      
    
    
    ];


    const showErrorToast = (errorText) => {
      const errorMessage =
      errorText ||
        "Unknown error occurred";
  
      toastInstance.current.show({
        title: "Validation Error",
        content: errorMessage,
        cssClass: "e-toast-danger", // red theme
        showCloseButton: true,
        timeOut: 30000, // 30 seconds
        extendedTimeout: 0, // prevent auto-dismiss on hover
      });
    };

    const insertRow =  async (isUpdate = false)=>{
              setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 700);

   let validateObject = {
        invoiceType:inputProps.invoiceType.value.value ||   'Sale Invoice',
        invoiceDate: moment(inputProps.invoiceDate.value).format('YYYY-MM-DD') || '2025-06-30',
        sellerNTNCNIC:inputProps.sellerNTNCNIC.value,
        sellerBusinessName:inputProps.sellerBusinessName.value,
        sellerProvince: inputProps.sellerProvince.value,
        sellerAddress: inputProps.sellerAddress.value,
        buyerNTNCNIC: inputProps.buyerNTNCNIC.value,
        buyerBusinessName: inputProps.buyerBusinessName.value,
        buyerProvince: inputProps.buyerProvince.value,
        buyerAddress: inputProps.buyerAddress.value,
        buyerRegistrationType: inputProps.buyerRegistrationType.value,
        invoiceRefNo:inputProps.invoiceRefNo.value ,
        scenarioId: props.isTesting == true ? (inputProps.scenarioId.value || '').toUpperCase() : '',
        items: [
          {
            invoiceType:inputProps.invoiceType.value.value || document.getElementById('invoiceType').value,
            invoiceDateForGrid:moment(inputProps.invoiceDate.value).format('YYYY-MM-DD') || '2025-06-30',
            rowID:isUpdate == true ? inputProps.rowID.value : inputProps.GridDataSource.value.length + 1,
            hsCode: inputProps.hsCode.value.id || document.getElementById('hsCodeID').value,
            hsCodeValue: inputProps.hsCode.value.value || document.getElementById('hsCode').value,
            productDescription:inputProps.productDescription.value,
            rate:inputProps.rate.value.value || document.getElementById('rate').value,
            uoM: inputProps.uoM.value.value || document.getElementById('uoM').value,
            quantity:Number(inputProps.quantity.value),
            totalValues:Number(inputProps.totalValues.value),
            valueSalesExcludingST: Number(inputProps.valueSalesExcludingST.value),
            fixedNotifiedValueOrRetailPrice: Number(inputProps.fixedNotifiedValueOrRetailPrice.value),
            salesTaxApplicable: Number(inputProps.salesTaxApplicable.value),
            salesTaxWithheldAtSource: Number(inputProps.salesTaxWithheldAtSource.value),
            extraTax: inputProps.extraTax.value || '',
            furtherTax: Number(inputProps.furtherTax.value),
            sroScheduleNo:inputProps.sroScheduleNo.value.value || '',
            fedPayable: Number(inputProps.fedPayable.value),
            discount: Number(inputProps.discount.value),
            saleType: inputProps.saleType.value.value || '',
            sroItemSerialNo: inputProps.sroItemSerialNo.value.value || ''
          }
        ]
      }
      
      console.log("validateObject",validateObject);
      let CompanyID = inputProps.CompanyID.value;
      let validateResponse = props.isTesting == true ? await saleInvoiceService.validatePostDataTesting(CompanyID , validateObject) : await saleInvoiceService.validatePostData(CompanyID , validateObject);
      console.log(validateResponse);

      if(validateResponse.data.validationResponse.status == "Valid"){
        let GridDataSourceArray = []

        if(isUpdate){
          let findIndex = inputProps.GridDataSource.value.findIndex(
            (item) => item.rowID === validateObject.items[0].rowID
          );
          
          if (findIndex !== -1) {
            // make a copy of array
            let tempDataSource = [...inputProps.GridDataSource.value];
            console.log(tempDataSource)
            // replace row at found index
            tempDataSource.splice(findIndex, 1, validateObject.items[0]);
          
            // assign updated array
            GridDataSourceArray = tempDataSource?.length > 0 ? tempDataSource :  [...inputProps.GridDataSource.value];
          }else{
            GridDataSourceArray = [...inputProps.GridDataSource.value];
          }
          
        }else{   
           GridDataSourceArray = [...inputProps.GridDataSource.value ,validateObject.items[0]]
        }
         
        console.log(GridDataSourceArray);
        updateMainSecionsValue({
        CallGridDataSource:{value:true}
      })
        updateMainSecionsValue({
          ValidMainSectionValues:{value:validateObject},
          GridDataSource:{value:GridDataSourceArray},
        })
        updateMainSecionsValue({
          CallGridDataSource:{value:false}
        })
         updateMainSecionsValue({
          
          UpdateButton:{enabled:false,isClicked:false}
          
        })
        resetDetailSection(true)

        setTimeout(()=>updateSendDetails(),2000)


      }else{
                setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 700);

         updateMainSecionsValue({
          
          UpdateButton:{enabled:isUpdate,isClicked:false}
          
        })

        // showErrorToast(validateResponse.data.validationResponse.invoiceStatuses?.[0]?.error)
        const validationResponse = validateResponse?.data?.validationResponse;

if (validationResponse) {
  let errorMessage = null;

  if (Array.isArray(validationResponse.invoiceStatuses) && validationResponse.invoiceStatuses.length > 0) {
    // Take first invoice error
    errorMessage = validationResponse.invoiceStatuses[0]?.error;
  } else if (validationResponse.error) {
    // Fallback to general error field
    errorMessage = validationResponse.error;
  }

  if (errorMessage) {
    showErrorToast(errorMessage);
  }
}

       
      }


    }


    // GRID SECTION START
    
    let columns = [
      { field:"invoiceType",headerText:'invoice Type',width:'130',textAlign:'left' ,headerTextAlign:'center',other:[]},
      { field:"invoiceDateForGrid",headerText:'Invoice Date',width:'130',textAlign:'left' ,headerTextAlign:'center',other:[]},
      { field:"hsCodeValue",headerText:'HSCode Description',width:'400',textAlign:'left' ,headerTextAlign:'center',other:[]},
      { field:"saleType",headerText:'sale Type',width:'170',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
      { field:"productDescription",headerText:'Product Description',width:'160',textAlign:'left' ,headerTextAlign:'center',other:[]},
      { field:"rate",headerText:'Rate',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[]},
      { field:"uoM",headerText:'UOM',width:'150',textAlign:'left' ,headerTextAlign:'center',other:[]},
      
      { field:"quantity",headerText:'Quantity',width:'130',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n2'},'format':'n2','editType':'numericedit'}]},
      { field:"valueSalesExcludingST",headerText:'value of Sales Excl ST',width:'150',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n0'},'format':'n0','editType':'numericedit'}]},
      { field:"salesTaxApplicable",headerText:'Sales Tax',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n0'},'format':'n0','editType':'numericedit'}]},

      { field:"fixedNotifiedValueOrRetailPrice",headerText:'Fixed/notified value Or Retail Price',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n0'},'format':'n0','editType':'numericedit'}]},
      { field:"salesTaxWithheldAtSource",headerText:'ST Withheld at Source',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n0'},'format':'n0','editType':'numericedit'}]},
      { field:"extraTax",headerText:'Extra Tax',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
      
      
      
      
      { field:"furtherTax",headerText:'Further Tax',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n0'},'format':'n0','editType':'numericedit'}]},
      { field:"fedPayable",headerText:'FED Payable',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n0'},'format':'n0','editType':'numericedit'}]},
      
      { field:"discount",headerText:'Discount',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n0'},'format':'n0','editType':'numericedit'}]},

      { field:"totalValues",headerText:'Total Value',width:'130',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,edit:{format:'n2'},'format':'n2','editType':'numericedit'}]},
      
      { field:"sroScheduleNo",headerText:'SRO/Schedule No',width:'140',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
      { field:"sroItemSerialNo",headerText:'sro Item Serial No',width:'150',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
      
      








      // { field:"TransactionDate",headerText:'Transaction Date',width:'150',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,editType:'datepickeredit'}]},
      
     
    ];

    const setSelectedRowDetailMainSections = (selectedRow)=>{
      console.log(selectedRow)
      document.getElementById('hsCode').value = selectedRow?.hsCodeValue || ''
      document.getElementById('hsCodeID').value = selectedRow?.hsCode || ''
      document.getElementById('rate').value = selectedRow?.rate || ''
      document.getElementById('uoM').value = selectedRow?.uoM || ''
      document.getElementById('sroItemSerialNo').value = selectedRow?.sroItemSerialNo || ''
      document.getElementById('sroScheduleNo').value = selectedRow?.sroScheduleNo || ''
      
      updateMainSecionsValue({
        rowID:{name:'rowID' ,value:selectedRow.rowID},
       hsCode:{value: {id: selectedRow?.hsCode  ,value:selectedRow?.hsCodeValue || ''}},
       productDescription:{value: selectedRow.productDescription || ''},
       rate:{
         value: {id: selectedRow?.ratE_ID  ,value:selectedRow?.ratE_DESC || ''}},
       uoM:{
           value: {id: selectedRow?.uoM_ID  ,value:selectedRow?.uoM_DESC || ''}},
       quantity:{value: selectedRow.quantity || 0 },
       totalValues:{value: selectedRow.totalValues || 0  },
       valueSalesExcludingST:{value: selectedRow.valueSalesExcludingST || 0},
       fixedNotifiedValueOrRetailPrice:{value: selectedRow.fixedNotifiedValueOrRetailPrice || 0 },
       salesTaxApplicable:{ value: selectedRow.salesTaxApplicable || 0 },
       salesTaxWithheldAtSource:{ value: selectedRow.salesTaxWithheldAtSource || 0  },
       extraTax:{value: selectedRow.extraTax || '' },
       furtherTax:{  value: selectedRow.furtherTax || 0 },
       sroScheduleNo:{  value:{id:undefined ,value: selectedRow.sroScheduleNo || '' }},
       fedPayable:{value: selectedRow.fedPayable || 0  },
       discount:{value: selectedRow.discount || 0  },
       sroItemSerialNo:{ value: {id:undefined ,value:selectedRow.sroItemSerialNo || '' }},
       UpdateButton:{enabled:true,isClicked:false}
      })
      
      setTimeout(()=>{

        document.getElementById('hsCode').focus()
      },500)
      
    }

    const dialogRef = useRef(null);
        const showDialog = (header,title,actions =['OK']) => {
          return new Promise((resolve) => {
          // Destroy existing dialog if any
          if (dialogRef.current) {
            dialogRef.current.destroy();
          }
          const okButtons = actions.map((action) => ({
            buttonModel: {
              content: action,
              cssClass: 'e-flat',
              isPrimary: action === 'OK',
            },
            click: (e) => {
              hideDialog();
              resolve(action);
            },
          }));
          // Create a new dialog instance
          dialogRef.current = new DialogInput({
            content: ()=>(<>{title}</>),
            header:header,
            width:'340px',
            showButtons: true,
            buttons:okButtons
          });
          // Show the dialog programmatically
          dialogRef.current.show();

        });

        };
      const hideDialog = () =>{
        if (dialogRef.current) {
        }
        dialogRef.current.hide();
        dialogRef.current.destroy();
        dialogRef.current = null; // Clean up reference after destruction
      }

  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <ToastComponent
        ref={toastInstance}
        position={{ X: "Right", Y: "Top" }}
      />
              <StructuredGenerate   mainProps={props} title={`Sale Invoice ${props.isAdd == true ? `Add` : props.isView ? `View` : `Edit`}`} Inputs={inputsList}/>

              <StructuredGenerate   mainProps={props} title={``} Inputs={inputsDetailList}/>
             
          
         {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}  

         <DynamicInputGrid
        Id='SaleInvoiceDetail'
        
        ColumnsList={columns}
        GridDataSource= {[
          {
        DataSourceType:inputProps.CallGridDataSource.value ? 'Data' : 'REST',
        DataSource:inputProps.GridDataSource.value || [],
         }]
  }
        DefaultSortedColumnName={''}
      
        ListActionComplete={()=>{}}
        ToolbarClicking={async ( grids, args ,selectedRows  , getListService,saveData,dataSource)=>{
          console.log(args)
          console.log(selectedRows)
          console.log(dataSource)
         
          if(args?.item?.properties?.id == 'DeleteRow'){
            if(selectedRows == undefined){
          await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
        }else{
          
          let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to Delete ?</span> , ['OK','CANCEL'])
          console.log(dialogResult)
        if(dialogResult == 'OK'){
          console.log(inputProps.GridDataSource.value)
          
          let filterData = inputProps.GridDataSource.value.filter((row)=> row.rowID != selectedRows.rowID)
          console.log(filterData)

          updateMainSecionsValue({
            CallGridDataSource:{value:true}
          })
            updateMainSecionsValue({
              // ValidMainSectionValues:{value:validateObject},
              GridDataSource:{value:filterData},
            })
            updateMainSecionsValue({
              CallGridDataSource:{value:false}
            })
            
            resetDetailSection(false)
            setTimeout(()=>updateSendDetails(),1500)

          }
        
          }
          }


          
          if(args?.item?.properties?.id == 'editRow' && selectedRows != {} && selectedRows != undefined) {
            setSelectedRowDetailMainSections(selectedRows)
          }
        }}
        SelectRowByID={inputProps.SelectRowByID.value}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
        AllowTemplate={false}
        ToolbarOption={[ {  text: `Delete`, tooltipText: "Delete Row", id: "DeleteRow", disabled:false },{ text: "&#128221; edit", tooltipText: "editRow", id: "editRow", disabled: !true }]}
        AllowGrouping={false}
        AllowExcelExport={false}
        AllowPdfExport={false} 
        ShowColumnChooser={false}
        AllowPaging={true}
        AllowDataBound={false}
        ListSecurity={'ListSecurity'}
        // AddSecurity={'ShopTransferList'}
        EditSecurity={false}
        DeleteSecurity={true}
        DefaultSortedColumnSort={'Aescending'}
        FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
        GroupColumns={[]} 
        // ListDelete={[]}
        // DeleteType={'hard'} 
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        // GridSumColumns={[``]}
        AllowGridSum={true}
        // FooterSumCaption={[]}

        // rowDataBound={InvoiceService.rowBound}
        // EditActionCompleteType={'Add'}
            {...props}
            ></DynamicInputGrid>

         
         </div>
  );
}; 

export default SaleInvoiceAdd;
